import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {fadeInAnimation} from '../../animations/fade-in.animation';
import {IRouteTabs} from '../appointment-page/appointment-page.component';
import {firstValueFrom} from 'rxjs';
import {PanelUtilitiesActions} from '../../models/panel-utilities';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';
import {AppTourService} from '../../services/app-tour/app-tour.service';

@Component({
  selector: 'app-lateral-menu-modules',
  templateUrl: './lateral-menu-modules.component.html',
  styleUrls: ['./lateral-menu-modules.component.scss'],
  animations: [fadeInAnimation]
})
export class LateralMenuModulesComponent implements OnInit {

  @Input() items: IRouteTabs[] = [];
  @Input() itemSelectedId: string;
  @Output() selected: EventEmitter<string> = new EventEmitter<string>();
  constructor(
    private utilitiesService: UtilitiesService,
    private appTourService: AppTourService
  ) { }

  ngOnInit(): void {
  }

  async onEmitClickItem(item: IRouteTabs): Promise<void> {
    if (!item.disabled) {
      this.selected.emit(item.path);
      if (!this.appTourService.tourMode) {
        await this.utilitiesService.closePanelUtilities();
      }
    }
  }



}
